import axios from "axios";
import { Api } from "../api";
import { AxiosErrorService } from "@/service/";

const EventRepository = {
    
     /**
     * getEvents
     * 
     * @returns {Object} server response
     */ 
    async getEvents() {
        const res: any = await axios.create({ withCredentials: true }).get(Api.BACKEND_URL + Api.EVENTS).catch((error) => {
            return AxiosErrorService.handleError(error)
        });
        //console.log('Memberrepository: getMembers Response', res)
        return res
    },

     /**
     * getActiveEvent
     * 
     * @returns {Object} server response
     */ 
    async getActiveEvent() {
        const res: any = await axios.create({ withCredentials: true }).get(Api.BACKEND_URL + Api.ACTIVE_EVENT).catch((error) => {
            return AxiosErrorService.handleError(error)
        });
        //console.log('Memberrepository: getMembers Response', res)
        return res
    },    
}

export default EventRepository;